import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-row gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-4" }
const _hoisted_4 = { class: "flex flex-row gap-4" }

import { debounce } from "lodash-es";
import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { maskDateBR } from "@/common/utils/mask";

import { getDate } from "@/common/utils/dates";

import { baseInput, baseDate } from "@/common/components";

import { EquipmentType } from "@/common/types/equipment";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment-details',
  props: {
    data: {},
    title: {},
    width: { default: "100%" }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const payload = ref<Partial<EquipmentType>>({});

function update(key: keyof typeof payload.value) {
  emit("update-data", { [key]: payload.value[key] });
}

const debounceForm = debounce(update, 1000);

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-details",
    style: _normalizeStyle({ width: __props.width })
  }, [
    (payload.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.brand,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.brand) = $event)),
            value: payload.value.brand,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(debounceForm)('brand')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.brand")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(baseInput), {
              modelValue: payload.value.model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.model) = $event)),
              value: payload.value.model,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(debounceForm)('model')))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.model")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"]),
            _createVNode(_unref(baseInput), {
              modelValue: payload.value.serial_number,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.serial_number) = $event)),
              value: payload.value.serial_number,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(debounceForm)('serial_number')))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.serial_number")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(baseDate), {
              modelValue: payload.value.fabrication_date,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((payload.value.fabrication_date) = $event)),
                _cache[7] || (_cache[7] = ($event: any) => (_unref(debounceForm)('fabrication_date')))
              ],
              value: payload.value.fabrication_date,
              required: true,
              "value-mask": "YYYY-MM-DD",
              placeholder: "--/--/----"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.fabrication")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"]),
            _createVNode(_unref(baseDate), {
              modelValue: payload.value.expired_date,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((payload.value.expired_date) = $event)),
                _cache[9] || (_cache[9] = ($event: any) => (_unref(debounceForm)('expired_date')))
              ],
              value: payload.value.expired_date,
              required: true,
              "value-mask": "YYYY-MM-DD",
              placeholder: "--/--/----"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.expiration_date")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(baseDate), {
              modelValue: payload.value.calibration_date,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((payload.value.calibration_date) = $event)),
                _cache[11] || (_cache[11] = ($event: any) => (_unref(debounceForm)('calibration_date')))
              ],
              value: payload.value.calibration_date,
              required: true,
              "value-mask": "YYYY-MM-DD",
              placeholder: "--/--/----"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.calibration_date")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"]),
            _createVNode(_unref(baseDate), {
              modelValue: payload.value.next_calibration,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = ($event: any) => ((payload.value.next_calibration) = $event)),
                _cache[13] || (_cache[13] = ($event: any) => (_unref(debounceForm)('next_calibration')))
              ],
              value: payload.value.next_calibration,
              required: true,
              "value-mask": "YYYY-MM-DD",
              placeholder: "--/--/----"
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.next_calibration")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})